<section class="receipt">
  <div class="receipt-logo">
    <img src="../../../../../assets/rexpay/Confirmed.svg" />
  </div>
  <h3 class="mt-2">Payment successful</h3>
  <p>Please download your receipt below</p>

  <button
    class="btn__primary w-100 no-margin-l no-margin-r btn__md btn"
    (click)="downloadReceipt()"
    download
  >
    Download receipt
  </button>
</section>
